// Display helpers for the "Lakay <shop>" brand prefix.
//
// Shop names are stored without the prefix ("Babyvox"); the UI prepends
// "Lakay". These helpers guarantee the two words are always separated
// ("Lakay Babyvox", never "LakayBabyvox") and that the prefix is never
// doubled when a stored name already begins with it.

// "lakay" glued to a following letter/digit, at the start of a word only —
// so "Elakay" / "elakay.com" are left untouched.
const LAKAY_GLUED = /(^|[^\p{L}\p{N}])lakay(?=[\p{L}\p{N}])/giu;

export function separateLakayWord(text) {
  if (text === null || text === undefined) return "";
  return String(text).replace(LAKAY_GLUED, (match, before) => `${before}Lakay `);
}

const firstWord = (s) => s.split(/\s+/)[0].toLowerCase();
const lastWord = (s) => s.split(/\s+/).pop().toLowerCase();

// formatLakayShopTitle("Babyvox")                    → "Lakay Babyvox"
// formatLakayShopTitle("LakayBabyvox")               → "Lakay Babyvox"
// formatLakayShopTitle("Babyvox", "View Lakay")      → "View Lakay Babyvox"
// formatLakayShopTitle("Lakay Babyvox", "View Lakay") → "View Lakay Babyvox"
export function formatLakayShopTitle(shopName, prefix = "Lakay") {
  const cleanPrefix = separateLakayWord(prefix).replace(/\s+/g, " ").trim();
  let name = separateLakayWord(Array.isArray(shopName) ? shopName[0] : shopName)
    .replace(/\s+/g, " ")
    .trim();

  if (!name) return cleanPrefix;
  if (!cleanPrefix) return name;

  // Prefix ends with the same word the name starts with ("… Lakay" + "Lakay …").
  if (lastWord(cleanPrefix) === firstWord(name)) {
    name = name.split(" ").slice(1).join(" ");
    if (!name) return cleanPrefix;
  }
  return `${cleanPrefix} ${name}`;
}
